itsoftApp.createModule("toggleElements", ["cookie", "select"], function() {
    var module = this;
    var buttons = document.querySelectorAll(".js-action-btn");

    var closeWarning = function (target) {
        var elementId = target.getAttribute("data-hide-element");
        var element = document.querySelector("#" + elementId);
        if (element.classList.contains("g-hidden")) {
            element.classList.remove("g-hidden");
        }

        var warning = document.querySelector(".warning");

        if (warning) {
            warning.classList.add("g-hidden");
        }
    }

    var selectsInit = function () {
        var selects = document.querySelectorAll(".js-select:not(.js-invisible):not(.js-visible)");

        if (selects.length > 0) {

            Array.prototype.forEach.call(selects, function (select) {
                select.classList.add("js-visible");

                itsoftApp.modules.select.callback(select);
            });
        }
    }

    var onButtonClick = function (evt) {
        evt.preventDefault();
        var target = evt.currentTarget;

        closeWarning(target);
        selectsInit();

        itsoftApp.modules.cookie.setCookie(evt.currentTarget);
        // itsoftApp.modules.headerFix.updateHeaderHeight();
    }

    if (buttons.length > 0) {
        Array.prototype.forEach.call(buttons, function (button) {
            var isCookie = button.hasAttribute("data-save");

            if (isCookie && !(itsoftApp.modules.cookie.getCookie(button))) {
                button.addEventListener("click", onButtonClick);
            } else if (!isCookie) {
                button.addEventListener("click", onButtonClick);
            } else {
                closeWarning(button);
                selectsInit();
            }
        });
    } else {
        selectsInit();
    }
});